export enum GmsAccessRequestStatusEnum {
    Pending = "Pending",
    Approved = "Approved",
    Declined = "Declined"
}